export const MIN_SUBMIT_LOADER_MS = 1500;

export async function waitForMinimumSubmitLoader(startedAt, minimumMs = MIN_SUBMIT_LOADER_MS) {
  const elapsed = Date.now() - startedAt;
  if (elapsed < minimumMs) {
    await new Promise((resolve) => {
      setTimeout(resolve, minimumMs - elapsed);
    });
  }
}
